import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  he: {
    translation: {
      appName: "Accss",
      // Marketing nav
      m_nav_about: "אודות",
      m_nav_standard: "יישום, תקן 5568",
      m_nav_info: "מרכז מידע",
      m_nav_partners: "מסלול שותפים",
      m_nav_pricing: "מחירים",
      m_nav_contact: "יצירת קשר",
      m_nav_install: "מדריך התקנה",
      m_nav_support: "תמיכה טכנית",
      m_nav_login: "התחברות",
      m_nav_register: "הרשמה",

      // Marketing home
      m_home_title: "Accss – הנגשת אתרים",
      m_home_subtitle:
        "שכבת נגישות חכמה לאתר, עם דשבורד לניהול אתרים, הצהרת נגישות, ודוחות תאימות.",
      m_home_cta_primary: "התחל ניסיון חינם",
      m_home_cta_secondary: "צפה בהדגמה",
      m_home_cta_contact: "צור קשר עם המכירות",
      m_home_badge: "נגישות דור הבא",
      m_home_hero_title_1: "הפוך את האינטרנט",
      m_home_hero_title_2: "נגיש לכולם",
      m_home_hero_subtitle: "אוטומציית תאימות ושיפור חוויית משתמש עם ערכת הנגישות המונעת בבינה מלאכותית שלנו. עמידה בתקני WCAG 2.1, ADA ו-Section 508 ללא מאמץ.",
      m_home_hero_monitoring: "ניטור בזמן אמת",
      m_home_hero_accessible: "99.9% נגיש",
      m_home_stats_1: "תקן WCAG 2.1",
      m_home_stats_2: "ניהול Multi-Site",
      m_home_stats_3: "תמיכה 24/7",
      m_home_stats_4: "התקנה פשוטה",
      m_home_features_title: "כל מה שצריך לתאימות מלאה",
      m_home_features_subtitle: "הפלטפורמה שלנו מספקת את הכלים המתקדמים ביותר לניהול נגישות אינטרנטית מודרנית, מבדיקות אוטומטיות ועד לתיקונים בזמן אמת.",
      m_home_feature_1_title: "תאימות מלאה",
      m_home_feature_1_desc: "עמידה בתקני WCAG 2.1, ADA ו-Section 508 באופן אוטומטי עם מנוע הסריקה שלנו.",
      m_home_feature_2_title: "קלות שימוש",
      m_home_feature_2_desc: "רק שורת קוד אחת כדי לשנות את הנוכחות הדיגיטלית שלך. ללא אינטגרציה מורכבת או השבתות נדרשות.",
      m_home_feature_3_title: "בדיקות מונעות AI",
      m_home_feature_3_desc: "ניטור רציף ותיקונים אוטומטיים למחסומי נגישות נפוצים באמצעות רשתות נוירונים.",
      m_home_learn_more: "למד עוד",
      m_home_tools_title: "כלים מודרניים לצוותים מודרניים",
      m_home_tools_1_title: "אנליטיקס מפורטת",
      m_home_tools_1_desc: "עקוב אחר שיפורי ציון הנגישות שלך לאורך זמן עם נקודות נתונים מפורטות.",
      m_home_tools_2_title: "תיקונים בזמן אמת",
      m_home_tools_2_desc: "תקן בעיות מבניות ועיצוביות באופן מיידי ללא שינוי קוד המקור שלך.",
      m_home_tools_3_title: "היסטוריית בדיקות",
      m_home_tools_3_desc: "שמור רשומה של תאימות להגנה משפטית ודיווח לבעלי עניין.",
      m_home_cta_title: "מוכנים להפוך את האתר שלכם לנגיש?",
      m_home_cta_subtitle: "הצטרף לאלפי חברות המשתמשות ב-ACCSS כדי לבנות עולם דיגיטלי כולל. לא נדרש כרטיס אשראי כדי להתחיל את תקופת הניסיון של 14 יום שלך.",
      m_home_bullets_1: "ממשק נגישות מתקדם + התאמה אישית (White Label)",
      m_home_bullets_2: "הצהרת נגישות ניתנת לעריכה מתוך הדשבורד",
      m_home_bullets_3: "ניהול אתרים מרובים, Site Key לכל אתר",
      m_home_bullets_4: "בקרת שימוש: אתרים / תעבורה / קרדיטים ל‑AI",
      m_home_section_trusted: "הבחירה של עסקים שמעדיפים שקט משפטי ותפעולי",
      
      // Footer
      m_footer_desc: "מנוע הנגישות המוביל בעולם המופעל על ידי בינה מלאכותית. בונים אינטרנט כולל לכולם.",
      m_footer_product: "מוצר",
      m_footer_company: "חברה",
      m_footer_support: "תמיכה",
      m_footer_about_us: "אודותינו",
      m_footer_rights: "כל הזכויות שמורות",

      // Pricing
      m_pricing_title: "מחירים",
      m_pricing_subtitle: "תמחור לפי אתר, תעבורה וקרדיטים ל‑AI – שקוף וקל לניהול.",
      m_pricing_basic: "בסיסי",
      m_pricing_premium: "פרימיום",
      m_pricing_cta: "להתחיל עכשיו",

      // Install
      m_install_title: "מדריך התקנה",
      m_install_steps_1: "נרשמים ומאמתים מייל",
      m_install_steps_2: "רוכשים חבילה",
      m_install_steps_3: "מוסיפים אתר ומגדירים דומיין",
      m_install_steps_4: "מטמיעים את קוד ה‑Widget באתר",

      // Support
      m_support_title: "תמיכה טכנית",
      m_support_subtitle: "שאלות נפוצות ופתרון תקלות מהיר.",

      // Contact
      m_contact_title: "יצירת קשר",
      m_contact_name: "שם",
      m_contact_email: "אימייל",
      m_contact_phone: "טלפון (אופציונלי)",
      m_contact_website: "כתובת אתר (אופציונלי)",
      m_contact_message: "תיאור פניה",
      m_contact_send: "שליחה לצוות",
      m_contact_sent: "הפניה נשלחה. נחזור אליך בהקדם.",
      m_contact_error: "לא הצלחנו לשלוח כרגע. נסה שוב בעוד כמה דקות.",

      // Language
      m_lang_he: "עברית",
      m_lang_en: "English",

      // About page
      m_about_title: "אודות",
      m_about_subtitle: "Accss היא פלטפורמת SaaS לניהול שכבת נגישות לאתרי אינטרנט—עם דשבורד שמאפשר לבעלי אתרים וסוכנויות לשלוט בהטמעה, בנראות, ובהתאמות, לצד הצהרת נגישות, שימוש/תעבורה, והכנה למודול בדיקות (AI Audit).",
      m_about_what_unique_title: "מה מייחד אותנו",
      m_about_what_unique_1: "• ניהול Multi‑Site עם Site Key לכל אתר והגבלת דומיינים.",
      m_about_what_unique_2: "• White‑Label ברמת אתר: לוגו/שם מותג/טקסט שיווקי מתוך הדשבורד.",
      m_about_what_unique_3: "• תמחור שקוף: אתרים + תעבורה + קרדיטים ל‑AI (מוכן להתרחבות).",
      m_about_what_unique_4: "• שכבת וידג׳ט מוקשחת CSS: פחות \"נשברת\" בגלל עיצוב האתר המארח.",
      m_about_b2b_title: "עקרון חשוב (B2B)",
      m_about_b2b_desc: "אנחנו מעדיפים אמינות, עקביות, ונראות \"Enterprise\" על פני אפקטים. המטרה היא מערכת שקל לתפעל, להסביר, ולתחזק—עם תיעוד ברור וזרימה מהירה ל‑Install.",
      m_about_transparency_title: "שקיפות על תאימות",
      m_about_transparency_desc: "חשוב: תפריט נגישות הוא חלק מהפתרון—not a silver bullet. בעולמות של תקנים (למשל 5568/WCAG) נדרשת גם עבודה ברמת התוכן והקוד. לכן אנחנו משלבים שכבת UI + דשבורד + (בהמשך) בדיקות/המלצות כדי לסגור פערים בצורה מדידה.",

      // Standard page
      m_standard_title: "יישום, תקן 5568",
      m_standard_subtitle: "עמוד זה מסביר את הגישה שלנו ליישום נגישות והכנה לתקן הישראלי 5568 ול‑WCAG. זהו מידע כללי לתכנון עבודה—לפני פרודקשן מומלץ לבצע בדיקה מקצועית/משפטית לפי תחום הפעילות שלך.",
      m_standard_widget_does_title: "מה הווידג׳ט כן עושה",
      m_standard_widget_does_1: "• התאמות תצוגה: גודל טקסט, ניגודיות, הדגשת קישורים, עצירת אנימציות.",
      m_standard_widget_does_2: "• תוספות: פונט קריא, היפוך צבעים, מרווח שורות/אותיות, \"קו קריאה\".",
      m_standard_widget_does_3: "• הצהרת נגישות ציבורית עם ניהול מתוך הדשבורד.",
      m_standard_site_needs_title: "מה עדיין צריך ברמת האתר",
      m_standard_site_needs_1: "• טקסטים אלטרנטיביים (ALT) לתמונות ותוכן משמעותי.",
      m_standard_site_needs_2: "• מבנה כותרות תקין, Labels לטפסים, וניווט מקלדת מלא.",
      m_standard_site_needs_3: "• ניגודיות צבעים בתוכן עצמו, פוקוס ברור, ו‑ARIA במקומות הנכונים.",
      m_standard_ai_audit_title: "למה אנחנו מוסיפים AI Audit",
      m_standard_ai_audit_desc: "המטרה היא להפוך את הנגישות למשהו שנמדד ומתוחזק: סריקה, איתור בעיות נפוצות (למשל ALT חסר, שפה, כותרות, Labels) והצגת המלצות תיקון. זה לא מחליף מומחה—אבל חוסך זמן ומאפשר שיפור מתמשך.",

      // Info page
      m_info_title: "מרכז מידע",
      m_info_subtitle: "מדריכים קצרים ותכל׳סיים לניהול נגישות, התקנה, ותחזוקה. נרחיב כאן לתכנים נוספים ולשפות נוספות.",
      m_info_guide_1_title: "הטמעה נכונה (Snippets + דומיינים)",
      m_info_guide_1_desc: "הווידג׳ט נטען רק אם הדומיין מאושר לאותו Site Key ויש מנוי פעיל. זה מונע שימוש לא מורשה ומאפשר שליטה מלאה.",
      m_info_guide_2_title: "הצהרת נגישות – למה זה חשוב",
      m_info_guide_2_desc: "בעל האתר יכול לפרסם הצהרה מותאמת מתוך הדשבורד. זה נותן שקיפות, תיעוד, ונקודת קשר ברורה לפניות.",
      m_info_guide_3_title: "מודל תמחור: אתרים + תעבורה + AI",
      m_info_guide_3_desc: "עסקים שונים צורכים משאבים שונים. לכן המודל מאפשר גידול מדורג עם Add‑ons במקום חבילה \"אחת לכולם\".",
      m_info_read_more: "לקריאה",

      // Partners page
      m_partners_title: "מסלול שותפים",
      m_partners_subtitle: "מתאים לסוכנויות, בוני אתרים, חברות פיתוח, ויועצי נגישות. הרעיון: אתם מנהלים את הלקוח—ואנחנו מספקים תשתית נוחה, שקופה, וממותגת.",
      m_partners_benefits_title: "מה מקבלים",
      m_partners_benefits_1: "• ניהול Multi‑Site ללקוח עם Site Keys והגבלות דומיינים.",
      m_partners_benefits_2: "• White‑Label ברמת אתר (לוגו/שם/טקסט), כדי שתישארו בפרונט.",
      m_partners_benefits_3: "• מודל תמחור שמאפשר Upsell טבעי (אתרים/תעבורה/AI) במקום \"שדרוג כואב\".",
      m_partners_start_title: "איך מתחילים",
      m_partners_start_1: "• פותחים חשבון שותף (בשלב זה דרך טופס).",
      m_partners_start_2: "• מגדירים חבילות/תנאים מולנו (ריסלר/עמלה).",
      m_partners_start_3: "• מקבלים תבנית התקנה + תהליך Onboarding ללקוחות.",
      m_partners_cta_talk: "דברו איתנו",
      m_partners_cta_pricing: "לראות מחירון",

      // ---- Marketing v2 (layout / home / inner pages) ----
      mk_skip: "דילוג לתוכן הראשי",
      mk_nav_main_aria: "ניווט ראשי",
      mk_nav_start: "התחלה",
      mk_menu_open: "פתיחת תפריט",
      mk_menu_close: "סגירת תפריט",
      mk_switch_lang_aria: "Switch to English",
      mk_new_tab: "נפתח בכרטיסייה חדשה",
      mk_footer_disclaimer:
        "Accss מספקת כלי עזר לנגישות ולניהול הסכמות. השימוש בווידג׳ט ובכלים אינו מבטיח כשלעצמו עמידה בדרישות החוק או התקן; נגישות מלאה מחייבת גם התאמות בתוכן ובקוד של האתר, ומומלץ להיוועץ באיש מקצוע.",
      mk_hero_eyebrow: "נגישות ופרטיות לאתר — במקום אחד",
      mk_hero_point_1: "שורת קוד אחת או תוסף WordPress",
      mk_hero_point_2: "לא מאט את האתר",
      mk_hero_point_3: "עברית, RTL ושפות נוספות",
      mk_w_alt: "המחשה: חלונית כלי הנגישות של Accss פתוחה באתר, לצד כפתורי הנגישות והעוגיות",
      mk_w_title: "כלי נגישות",
      mk_w_sub: "ההתאמות נשמרות במכשיר שלך בלבד",
      mk_w_lang: "HE",
      mk_w_search: "חיפוש כלי…",
      mk_w_active: "2 התאמות פעילות",
      mk_w_reset: "איפוס",
      mk_w_tab_quick: "מהיר",
      mk_w_tab_text: "טקסט",
      mk_w_tab_colors: "צבעים",
      mk_w_tab_nav: "ניווט",
      mk_w_help: "מה יעזור לך עכשיו?",
      mk_w_p1_t: "תצוגה ברורה יותר",
      mk_w_p1_d: "טקסט גדול יותר, גופן קריא וניגודיות גבוהה",
      mk_w_p2_t: "קריאה וריכוז",
      mk_w_p2_d: "מסכת קריאה, מרווחים נוחים ועצירת אנימציות",
      mk_w_on: "פעיל",
      mk_trust_aria: "יתרונות עיקריים",
      mk_pillars_eyebrow: "המוצר",
      mk_pillars_title: "ארבעה כלים, דשבורד אחד",
      mk_pillars_sub: "וידג׳ט נגישות, ניהול הסכמות לעוגיות, מרכז תאימות וכלי AI — מנוהלים מאותו מקום, לכל האתרים שלכם.",
      mk_pillar_widget_t: "וידג׳ט נגישות",
      mk_pillar_widget_d: "חלונית נגישות מודרנית עם פרופילים מהירים, חיפוש כלים והתאמות טקסט, צבעים וניווט — במיתוג שלכם.",
      mk_pillar_widget_c1: "פרופילים מהירים",
      mk_pillar_widget_c2: "התאמות תצוגה",
      mk_pillar_widget_c3: "White Label",
      mk_pillar_privacy_t: "פרטיות ועוגיות (תיקון 13)",
      mk_pillar_privacy_d: "באנר הסכמה לעוגיות, כפתור העדפות נפרד ומדיניות פרטיות שמנוהלת מהדשבורד — כדי לעבוד בצורה מסודרת מול דרישות תיקון 13.",
      mk_pillar_privacy_c1: "באנר הסכמה",
      mk_pillar_privacy_c2: "העדפות עוגיות",
      mk_pillar_privacy_c3: "מדיניות פרטיות",
      mk_pillar_compliance_t: "מרכז תאימות והצהרת נגישות",
      mk_pillar_compliance_d: "הצהרת נגישות שעורכים מתוך הדשבורד, דוחות תאימות לכל אתר ותיעוד מסודר של השינויים לאורך זמן.",
      mk_pillar_compliance_c1: "הצהרת נגישות",
      mk_pillar_compliance_c2: "דוחות תאימות",
      mk_pillar_compliance_c3: "השוואת סריקות",
      mk_pillar_ai_d: "סריקת AI שמאתרת בעיות נפוצות — ALT חסר, מבנה כותרות, תוויות לטפסים — ומציעה המלצות תיקון. לא מחליפה מומחה, אבל חוסכת זמן.",
      mk_pillar_ai_c1: "AI Audit",
      mk_pillar_ai_c2: "ALT לתמונות",
      mk_pillar_ai_c3: "הצעות ניגודיות",
      mk_how_eyebrow: "איך זה עובד",
      mk_how_title: "באוויר תוך דקות",
      mk_how_sub: "שלושה צעדים פשוטים, בלי פרויקט פיתוח ובלי לשנות את עיצוב האתר.",
      mk_how_1_t: "מוסיפים אתר",
      mk_how_1_d: "פותחים חשבון, מוסיפים את הדומיין ומקבלים Site Key ייעודי לאתר.",
      mk_how_2_t: "מתאימים",
      mk_how_2_d: "בוחרים צבעים, מיקום, שפה וכלים, ועורכים את הצהרת הנגישות ומדיניות הפרטיות.",
      mk_how_3_t: "מתקינים",
      mk_how_3_d: "מתקינים את תוסף ה‑WordPress או מדביקים שורת קוד אחת — והווידג׳ט באוויר.",
      mk_install_eyebrow: "התקנה",
      mk_install_title: "התקנה פשוטה, בלי להאט את האתר",
      mk_install_sub: "קוד ההטמעה נטען רק אחרי שהדף סיים להיטען, ברקע — כך שהאתר שלכם נשאר מהיר.",
      mk_install_point_1: "קוד לא חוסם: נטען אחרי טעינת הדף ובזמן סרק של הדפדפן",
      mk_install_point_2: "תוסף WordPress — מתחברים לחשבון או מדביקים Site Key, וזהו",
      mk_install_point_3: "הווידג׳ט פועל רק בדומיינים שאישרתם",
      mk_install_tabs_aria: "שיטות התקנה",
      mk_install_tab_code: "שורת קוד",
      mk_install_tab_wp: "תוסף WordPress",
      mk_install_code_note: "את הקוד המלא, עם ה‑Site Key שלכם, מעתיקים מהדשבורד בלחיצה.",
      mk_install_wp_1: "מתקינים ומפעילים את התוסף Accss Accessibility",
      mk_install_wp_2: "מתחברים לחשבון Accss או מדביקים את ה‑Site Key",
      mk_install_wp_3: "שומרים — והווידג׳ט מופיע באתר",
      mk_install_wp_note: "התוסף משתמש באותה טעינה לא חוסמת כמו קוד ההטמעה.",
      mk_resilience_t: "לא מאט את האתר — גם אם השירות שלנו לא זמין",
      mk_resilience_d: "הקוד נטען באופן אסינכרוני ורק אחרי שהדף סיים להיטען. אם השרת של Accss לא זמין מסיבה כלשהי, האתר שלכם ממשיך לעבוד כרגיל — פשוט בלי הווידג׳ט, עד שהשירות חוזר.",
      mk_resilience_pill_1: "טעינה לא חוסמת",
      mk_resilience_pill_2: "האתר תמיד עובד",
      mk_pricing_teaser_t: "תמחור שקוף שגדל איתכם",
      mk_pricing_teaser_cta: "לכל החבילות",
      mk_faq_eyebrow: "שאלות נפוצות",
      mk_faq_title: "שאלות ותשובות",
      mk_faq_1_q: "האם הווידג׳ט משפיע על מהירות האתר?",
      mk_faq_1_a: "לא באופן מורגש. הקוד נטען רק אחרי שהדף סיים להיטען ובזמן סרק של הדפדפן, כך שהוא לא חוסם את הרינדור. וגם אם השירות שלנו לא זמין — האתר ממשיך לעבוד כרגיל.",
      mk_faq_2_q: "האם התקנת הווידג׳ט מספיקה כדי לעמוד בחוק?",
      mk_faq_2_a: "לא בהכרח. הווידג׳ט הוא כלי עזר שמשפר את חוויית הגלישה, אבל נגישות לפי תקן 5568 ו‑WCAG דורשת גם עבודה ברמת התוכן והקוד — טקסט חלופי לתמונות, מבנה כותרות, תוויות לטפסים וניווט מקלדת. הכלים בדשבורד עוזרים לאתר ולתעד את הפערים.",
      mk_faq_3_q: "איך מתקינים באתר WordPress?",
      mk_faq_3_a: "מתקינים את התוסף Accss Accessibility, מתחברים לחשבון או מדביקים את ה‑Site Key מהדשבורד, ושומרים. באתרים אחרים מדביקים שורת קוד אחת בתבנית האתר.",
      mk_faq_4_q: "מה כולל ניהול העוגיות (תיקון 13)?",
      mk_faq_4_a: "באנר הסכמה לעוגיות, כפתור העדפות נפרד שמאפשר לגולשים לשנות את בחירתם בכל רגע, ומדיניות פרטיות שאתם עורכים מתוך הדשבורד.",
      mk_faq_5_q: "אפשר לנהל כמה אתרים מאותו חשבון?",
      mk_faq_5_a: "כן. כל אתר מקבל Site Key משלו והגבלת דומיינים, ואפשר לנהל את כולם מאותו דשבורד — מתאים גם לסוכנויות ולמסלול השותפים.",

      // Pricing page
      mk_pr_eyebrow: "תמחור",
      mk_pr_interval_aria: "תקופת חיוב",
      mk_pr_per_month: "לחודש",
      mk_pr_per_year: "לשנה",
      mk_pr_includes: "כולל:",
      mk_pr_sites: "עד {{n}} אתרים",
      mk_pr_pageviews: "{{n}} טעינות דף בחודש",
      mk_pr_ai: "{{n}} קרדיטי AI בחודש",
      mk_pr_extra_site: "אתר נוסף: ₪{{p}} לחודש",
      mk_pr_popular: "מומלץ",
      mk_pr_empty: "אין חבילות להצגה כרגע. דברו איתנו ונתאים לכם חבילה.",
      mk_pr_note: "בכל החבילות: טעינה לא חוסמת שלא מאטה את האתר, וניהול מלא מתוך הדשבורד.",
      mk_pr_custom_t: "צריכים חבילה מותאמת אישית?",
      mk_pr_custom_d: "סוכנויות, ריבוי אתרים או נפחי תעבורה גבוהים — נבנה יחד חבילה שמתאימה לכם.",
      mk_pr_custom_cta: "דברו איתנו",
      mk_feat_font: "הגדלת/הקטנת טקסט",
      mk_feat_contrast: "ניגודיות גבוהה",
      mk_feat_links: "הדגשת קישורים",
      mk_feat_stopAnimations: "עצירת אנימציות",
      mk_feat_invertColors: "היפוך צבעים",
      mk_feat_readableFont: "פונט קריא",
      mk_feat_readLine: "קו קריאה",
      mk_feat_lineHeight: "שליטה במרווח שורות",
      mk_feat_letterSpacing: "שליטה במרווח אותיות",
      mk_feat_statement: "הצהרת נגישות",
      mk_feat_aiAudit: "בדיקת נגישות חכמה (AI Audit)",
      mk_feat_aiAltText: "ALT אוטומטי לתמונות (AI)",
      mk_feat_aiColorSuggestions: "הצעות צבע/קונטרסט (AI)",
      mk_feat_whiteLabel: "White Label (ללא מיתוג Accss)",
      mk_feat_branding: "מיתוג מותאם אישית",

      // Inner pages
      mk_about_eyebrow: "מי אנחנו",
      mk_standard_eyebrow: "תקן 5568 · WCAG",
      mk_standard_disclaimer_t: "חשוב לדעת",
      mk_info_eyebrow: "מדריכים",
      mk_partners_eyebrow: "לסוכנויות ולבוני אתרים",
      mk_install_page_eyebrow: "התקנה",
      mk_install_page_sub: "תהליך התקנה ברור, מדיד ומנוהל. בתוך דקות מקבלים Site Key והווידג׳ט פעיל (בכפוף לדומיין מאושר ולמנוי פעיל).",
      mk_install_page_steps_t: "ארבעה צעדים להתקנה",
      mk_install_page_method_t: "שתי דרכים להטמיע",
      mk_install_start: "התחלה",
      mk_install_pricing: "מחירון",
      mk_install_issues: "תקלות נפוצות",
      mk_support_eyebrow: "עזרה",
      mk_support_faq_t: "שאלות נפוצות",
      mk_sup_1_q: "האם התוסף משפיע על מהירות האתר?",
      mk_sup_1_a: "הווידג׳ט נטען בסוף טעינת הדף (לא חוסם רנדר). בפועל ההשפעה זניחה, במיוחד בהטמעה נכונה.",
      mk_sup_2_q: "למה הווידג׳ט לא נטען לי בדף מקומי (file://)?",
      mk_sup_2_a: "השרת מאמת דומיין לפי Origin/Referer. בקובץ מקומי אין Origin תקין—כדאי לבדוק דרך {{url}}.",
      mk_sup_3_q: "איך מוסיפים כמה דומיינים לאותו אתר?",
      mk_sup_3_a: "בעריכת אתר בשדה 'דומיין' אפשר להוסיף רשימה מופרדת בפסיקים (כולל *.example.com לתתי־דומיין).",
      mk_support_more_t: "לא מצאתם תשובה?",
      mk_support_more_d: "כתבו לנו ונחזור אליכם עם פתרון.",
      mk_contact_eyebrow: "דברו איתנו",
      mk_contact_sub: "להדגמה, שאלות על תמחור או עזרה טכנית בהטמעה — השאירו פרטים ונחזור אליכם.",
      mk_contact_form_t: "השאירו פרטים",
      mk_contact_side_t: "במה נוכל לעזור",
      mk_contact_side_1: "הדגמה של הווידג׳ט והדשבורד",
      mk_contact_side_2: "שאלות על חבילות ותמחור",
      mk_contact_side_3: "עזרה בהתקנה ובהגדרת דומיינים",
      mk_contact_side_4: "שיתופי פעולה ומסלול שותפים",

      // Auth pages
      mka_login_title: "התחברות",
      mka_login_sub: "התחברו כדי לנהל את האתרים שלכם",
      mka_login_btn: "התחברות",
      mka_login_err: "שגיאה בהתחברות",
      mka_google_login: "התחברות עם Google",
      mka_google_register: "הרשמה עם Google",
      mka_or: "או עם אימייל",
      mka_email: "אימייל",
      mka_password: "סיסמה",
      mka_name: "שם",
      mka_forgot_link: "שכחתי סיסמה",
      mka_no_account: "אין לך משתמש?",
      mka_register_link: "הרשמה",
      mka_have_account: "כבר יש לך משתמש?",
      mka_login_link: "התחברות",
      mka_register_title: "יצירת חשבון",
      mka_register_sub: "מוסיפים אתר, מתאימים ומתקינים — תוך דקות",
      mka_register_btn: "יצירת חשבון",
      mka_register_err: "שגיאה בהרשמה",
      mka_forgot_title: "שכחתי סיסמה",
      mka_forgot_sub: "הזינו את האימייל שלכם ונשלח קישור לאיפוס הסיסמה",
      mka_forgot_btn: "שלח קישור לאיפוס",
      mka_forgot_done: "אם האימייל קיים במערכת, נשלח אליו קישור לאיפוס.",
      mka_back_login: "חזרה להתחברות",
      mka_err: "שגיאה",
      mka_set_title: "קביעת סיסמה",
      mka_set_sub: "בחרו סיסמה חדשה לחשבון שלכם",
      mka_set_missing: "חסר token בקישור",
      mka_set_done: "הסיסמה עודכנה.",
      mka_set_new: "סיסמה חדשה",
      mka_set_btn: "שמירה",
      mka_show_password: "הצגת סיסמה",
      mka_hide_password: "הסתרת סיסמה",
      mka_google_progress: "מתחבר עם Google…",
      mka_google_fail: "התחברות עם Google נכשלה. נסה שוב.",

      // Payment result pages
      mkp_checking: "בודק סטטוס תשלום...",
      mkp_success_title: "התשלום הצליח",
      mkp_msg_default: "התשלום בוצע בהצלחה! המנוי שלך יתעדכן בקרוב.",
      mkp_msg_completed: "התשלום אושר והמנוי שלך הופעל!",
      mkp_msg_pending: "התשלום מעובד. המנוי יתעדכן בעוד מספר דקות.",
      mkp_msg_done: "התשלום בוצע. המנוי שלך יתעדכן בקרוב.",
      mkp_msg_soon: "התשלום בוצע בהצלחה! המנוי שלך יתעדכן בעוד מספר רגעים.",
      mkp_tx: "מזהה עסקה:",
      mkp_back_dash: "חזרה לדשבורד",
      mkp_my_sites: "האתרים שלי",
      mkp_email_note: "קיבלת אימייל עם פרטי ההזמנה.",
      mkp_fail_title: "התשלום נכשל",
      mkp_fail_msg: "התשלום לא הושלם. אפשר לנסות שוב.",
      mkp_cancel_title: "התשלום בוטל",
      mkp_cancel_msg: "התשלום בוטל.",
      mkp_back_plans: "חזרה לחבילות",
      mkp_demo_title: "מצב בדיקה (Demo)",
      mkp_demo_warning: "זהו מצב בדיקה. לא יתבצע תשלום אמיתי.",
      mkp_demo_amount: "סכום:",
      mkp_demo_iframe: "במצב ייצור, כאן יופיע iframe התשלום של SmartPay.",
      mkp_demo_redirect: "מעביר לעמוד הצלחה בעוד {{n}} שניות...",
      mkp_demo_continue: "המשך להצלחה",
      mkp_demo_fail: "סימולציה: כשלון",
      mkp_demo_cancel: "ביטול",
      mkp_demo_env: "כדי להפעיל תשלומים אמיתיים, הגדר את משתני הסביבה של SmartPay ב-",

      // Plans page
      p_plans_title: "חבילות",
      p_addons_title: "תוספים (Add-ons)",
      p_buy_button: "רכישה",
      p_yearly: "שנתי",
      p_monthly: "חודשי",
      p_features_label: "פיצ'רים",
      p_includes: "כולל עד",
      p_sites_label: "אתרים",
      p_pageviews_label: "טעינות/חודש",
      p_ai_credits_label: "קרדיטי AI/חודש",
      p_no_ai_credits: "ללא קרדיטי AI",
      p_overage_traffic: "חריגה בתעבורה:",
      p_per_1000: "לכל 1,000 טעינות",
      p_extra_site: "אתר נוסף:",
      p_per_month: "/חודש",
      p_payment_title: "תשלום מאובטח בכרטיס אשראי",
      p_payment_success: "התשלום הצליח. המנוי מתעדכן…",
      p_payment_failed: "התשלום לא הושלם. אפשר לנסות שוב.",
      p_payment_pending: "הכנס פרטי תשלום ב‑IFRAME. אחרי אישור—החבילה תתעדכן אוטומטית.",
      p_payment_no_url: "לא התקבל קישור לתשלום.",
      p_payment_open_new_window: "פתח בחלון חדש",
      p_payment_close: "סגור",

      // Profile page
      pr_profile_title: "פרופיל",
      pr_email_label: "אימייל:",
      pr_dark_mode: "מצב כהה",
      pr_light_mode: "מצב בהיר",
      pr_theme_desc: "מצב התצוגה נשמר בדפדפן (Light/Dark) ומוחל על כל המערכת.",
      pr_name_label: "שם",
      pr_save_button: "שמירה",
      pr_updated_message: "עודכן.",

      // Usage Dashboard
      usage_title: "שימוש ותעבורה",
      usage_month_label: "חודש:",
      usage_metric_desc: "המדד כרגע הוא \"טעינות config\" של ה‑Widget (MVP).",
      usage_sites_count: "אתרים:",
      usage_total_hits: "סה״כ טעינות החודש:",
      usage_plan_label: "Plan:",
      usage_quota_per_site: "מכסה לכל אתר:",
      usage_no_limit: "ללא מגבלה",
      usage_ai_credits_month: "AI credits/חודש:",
      usage_extra_sites: "תוספת אתרים:",
      usage_extra_traffic: "תוספת תעבורה/חודש:",
      usage_extra_ai: "תוספת AI/חודש:",
      usage_no_subscription: "אין מנוי פעיל",
      usage_table_site: "אתר",
      usage_table_domain: "דומיין",
      usage_table_hits_month: "טעינות החודש",
      usage_table_utilization: "ניצול",
      usage_table_remaining: "נשאר",
      usage_table_status: "סטטוס",
      usage_status_exceeded: "חריגה מהחבילה · הווידג׳ט ממשיך לפעול",

      overview: "סקירה",
      dashboard: "דשבורד",
      usage: "שימוש",
      theme_dark: "מצב כהה",
      theme_light: "מצב בהיר",
      back_to_marketing: "חזרה לאתר השיווקי",
      marketing_site: "לאתר השיווקי",
      open_menu: "פתיחת תפריט",
      toggle_sidebar: "צמצום/הרחבת תפריט",

      login: "התחברות",
      register: "הרשמה",
      email: "אימייל",
      password: "סיסמה",
      name: "שם",
      logout: "התנתקות",
      profile: "פרופיל",
      plans: "חבילות",
      sites: "אתרים",
      admin: "אדמין",
      collapse: "מזער תפריט",
      expand: "הרחב תפריט",
      settings: "הגדרות",
      forgotPassword: "שכחתי סיסמה",
      setPassword: "קביעת סיסמה",
      save: "שמירה",
      create: "יצירה",
      edit: "עריכה",
      delete: "מחיקה",
      install: "הטמעה",
      domain: "דומיין",
      siteName: "שם האתר",
      siteKey: "Site Key",
      copy: "העתק",
      cancel: "ביטול",

      // Sites page
      sites_subtitle: "ניהול האתרים והקונפיגורציות שלך",
      sites_add_website: "הוסף אתר",
      sites_no_sites: "אין אתרים עדיין. הוסף אתר ראשון להתחיל.",
      sites_table_name: "שם האתר",
      sites_table_status: "סטטוס",
      sites_table_action: "פעולות",
      sites_confirm_delete: "למחוק את האתר?",
      sites_menu_quickstart: "התחלה מהירה",
      sites_menu_edit: "הגדרות",
      sites_menu_install: "קוד התקנה",
      sites_menu_statement: "הצהרת נגישות",
      sites_menu_reports: "דוחות תאימות",
      sites_menu_delete: "מחיקת אתר",
      sites_dialog_title: "הוסף אתר חדש",
      sites_dialog_subtitle: "הגדר את האינטגרציה של האתר שלך",
      sites_name_placeholder: "האתר שלי",
      sites_name_help: "שם ידידותי לאתר שלך",
      sites_domain_help: "רשימה מופרדת בפסיקים של דומיינים",

      // Settings page
      settings_subtitle: "ניהול הפרופיל והחשבון שלך",
      settings_tab_profile: "פרופיל",
      settings_tab_billing: "חיוב ותשלום",
      settings_profile_title: "מידע אישי",
      settings_name_help: "השם שיוצג בחשבון שלך",
      settings_email_help: "לא ניתן לשנות את כתובת האימייל",
      settings_appearance_title: "מראה",
      settings_billing_title: "ניהול מנוי ותשלום",
      settings_billing_desc: "נהל את פרטי התשלום, שיטות החיוב וההיסטוריה שלך",
      settings_payment_portal: "פורטל ניהול תשלומים",
      settings_payment_portal_desc: "עדכן אמצעי תשלום, צפה בחשבוניות והיסטוריה",
      settings_opening: "פותח...",
      settings_open_portal: "פתח פורטל ניהול",
      settings_subscription_info: "פרטי מנוי",
      settings_subscription_desc: "לצפייה ושינוי החבילה שלך",
      settings_view_plans: "צפה בחבילות",
    },
  },
  en: {
    translation: {
      appName: "Accss",
      m_nav_about: "About",
      m_nav_standard: "Israeli Standard 5568",
      m_nav_info: "Knowledge Center",
      m_nav_partners: "Partners",
      m_nav_pricing: "Pricing",
      m_nav_contact: "Contact",
      m_nav_install: "Install Guide",
      m_nav_support: "Support",
      m_nav_login: "Login",
      m_nav_register: "Register",
      m_home_title: "Accss – Website Accessibility",
      m_home_subtitle:
        "An accessibility layer for your site with a dashboard for sites, statements, and compliance reports.",
      m_home_cta_primary: "Start Free Trial",
      m_home_cta_secondary: "View Demo",
      m_home_cta_contact: "Contact Sales",
      m_home_badge: "Next-Gen Accessibility",
      m_home_hero_title_1: "Make the Web",
      m_home_hero_title_2: "Accessible for Everyone",
      m_home_hero_subtitle: "Automate compliance and enhance user experience with our AI-driven accessibility suite. Meet WCAG 2.1, ADA, and Section 508 standards effortlessly.",
      m_home_hero_monitoring: "Real-Time Monitoring",
      m_home_hero_accessible: "99.9% Accessible",
      m_home_stats_1: "WCAG 2.1 Standard",
      m_home_stats_2: "Multi-Site Management",
      m_home_stats_3: "24/7 Support",
      m_home_stats_4: "Easy Integration",
      m_home_features_title: "Everything you need for full compliance",
      m_home_features_subtitle: "Our platform provides the most advanced tools for modern web accessibility management, from automated audits to real-time remediations.",
      m_home_feature_1_title: "Full Compliance",
      m_home_feature_1_desc: "Meet WCAG 2.1, ADA, and Section 508 standards automatically with our scanning engine.",
      m_home_feature_2_title: "Ease of Use",
      m_home_feature_2_desc: "Just one line of code to transform your digital presence. No complex integration or downtime required.",
      m_home_feature_3_title: "AI-Driven Audits",
      m_home_feature_3_desc: "Continuous monitoring and automated fixes for common accessibility barriers using neural networks.",
      m_home_learn_more: "Learn more",
      m_home_tools_title: "Modern tools for modern teams",
      m_home_tools_1_title: "Detailed Analytics",
      m_home_tools_1_desc: "Track your accessibility score improvements over time with granular data points.",
      m_home_tools_2_title: "Real-time Remediations",
      m_home_tools_2_desc: "Fix structural and design issues on-the-fly without changing your source code.",
      m_home_tools_3_title: "Audit History",
      m_home_tools_3_desc: "Maintain a record of compliance for legal protection and stakeholder reporting.",
      m_home_cta_title: "Ready to make your site accessible?",
      m_home_cta_subtitle: "Join thousands of companies using ACCSS to build an inclusive digital world. No credit card required to start your 14-day trial.",
      m_home_bullets_1: "Advanced accessibility UI + White Label options",
      m_home_bullets_2: "Editable accessibility statement from the dashboard",
      m_home_bullets_3: "Multi-site management with a unique Site Key per site",
      m_home_bullets_4: "Usage controls: sites / traffic / AI credits",
      m_home_section_trusted: "Trusted by teams who want operational peace of mind",
      
      // Footer
      m_footer_desc: "The world's leading accessibility engine powered by artificial intelligence. Building an inclusive web for everyone.",
      m_footer_product: "Product",
      m_footer_company: "Company",
      m_footer_support: "Support",
      m_footer_about_us: "About Us",
      m_footer_rights: "All rights reserved",
      m_pricing_title: "Pricing",
      m_pricing_subtitle: "Pricing per site, traffic, and AI credits — transparent and scalable.",
      m_pricing_basic: "Basic",
      m_pricing_premium: "Premium",
      m_pricing_cta: "Get started",
      m_install_title: "Install Guide",
      m_install_steps_1: "Register and verify email",
      m_install_steps_2: "Purchase a plan",
      m_install_steps_3: "Add a site and approve domain(s)",
      m_install_steps_4: "Embed the widget snippet on your site",
      m_support_title: "Support",
      m_support_subtitle: "FAQs and quick troubleshooting.",
      m_contact_title: "Contact",
      m_contact_name: "Name",
      m_contact_email: "Email",
      m_contact_phone: "Phone (optional)",
      m_contact_website: "Website (optional)",
      m_contact_message: "Message",
      m_contact_send: "Send",
      m_contact_sent: "Sent. We'll get back to you soon.",
      m_contact_error: "Could not send right now. Please try again later.",
      m_lang_he: "Hebrew",
      m_lang_en: "English",

      // About page
      m_about_title: "About",
      m_about_subtitle: "Accss is a SaaS platform for managing website accessibility—with a dashboard that enables website owners and agencies to control implementation, branding, and customizations, alongside accessibility statements, usage/traffic monitoring, and preparation for AI Audit modules.",
      m_about_what_unique_title: "What Makes Us Unique",
      m_about_what_unique_1: "• Multi-Site management with a unique Site Key per site and domain restrictions.",
      m_about_what_unique_2: "• White-Label at site level: logo/brand name/marketing text from the dashboard.",
      m_about_what_unique_3: "• Transparent pricing: sites + traffic + AI credits (ready for expansion).",
      m_about_what_unique_4: "• Hardened CSS widget layer: less likely to \"break\" due to host site design.",
      m_about_b2b_title: "Important Principle (B2B)",
      m_about_b2b_desc: "We prioritize reliability, consistency, and \"Enterprise\" appearance over flashy effects. The goal is a system that's easy to operate, explain, and maintain—with clear documentation and a quick flow to Install.",
      m_about_transparency_title: "Transparency on Compliance",
      m_about_transparency_desc: "Important: Accessibility menu is part of the solution—not a silver bullet. In the world of standards (e.g., 5568/WCAG), work is also required at the content and code level. That's why we combine UI layer + dashboard + (upcoming) audits/recommendations to close gaps measurably.",

      // Standard page
      m_standard_title: "Implementation, Standard 5568",
      m_standard_subtitle: "This page explains our approach to accessibility implementation and preparation for Israeli Standard 5568 and WCAG. This is general information for planning work—before production, we recommend professional/legal review based on your field of activity.",
      m_standard_widget_does_title: "What the Widget Does",
      m_standard_widget_does_1: "• Display adjustments: text size, contrast, link highlighting, animation stopping.",
      m_standard_widget_does_2: "• Additions: readable font, color inversion, line/letter spacing, \"reading line\".",
      m_standard_widget_does_3: "• Public accessibility statement with management from the dashboard.",
      m_standard_site_needs_title: "What's Still Needed at Site Level",
      m_standard_site_needs_1: "• Alternative texts (ALT) for images and meaningful content.",
      m_standard_site_needs_2: "• Proper heading structure, form labels, and full keyboard navigation.",
      m_standard_site_needs_3: "• Color contrast in the content itself, clear focus, and ARIA in the right places.",
      m_standard_ai_audit_title: "Why We're Adding AI Audit",
      m_standard_ai_audit_desc: "The goal is to make accessibility something measured and maintained: scanning, detecting common issues (e.g., missing ALT, language, headings, labels), and providing fix recommendations. It doesn't replace an expert—but saves time and enables continuous improvement.",

      // Info page
      m_info_title: "Knowledge Center",
      m_info_subtitle: "Quick and practical guides for accessibility management, installation, and maintenance. We'll expand with more content and languages.",
      m_info_guide_1_title: "Proper Installation (Snippets + Domains)",
      m_info_guide_1_desc: "The widget loads only if the domain is approved for that Site Key and there's an active subscription. This prevents unauthorized use and enables full control.",
      m_info_guide_2_title: "Accessibility Statement – Why It Matters",
      m_info_guide_2_desc: "Site owners can publish a customized statement from the dashboard. This provides transparency, documentation, and a clear contact point for inquiries.",
      m_info_guide_3_title: "Pricing Model: Sites + Traffic + AI",
      m_info_guide_3_desc: "Different businesses consume different resources. Therefore, the model enables gradual growth with add-ons instead of a \"one-size-fits-all\" package.",
      m_info_read_more: "Read more",

      // Partners page
      m_partners_title: "Partners Track",
      m_partners_subtitle: "Suitable for agencies, site builders, development companies, and accessibility consultants. The idea: you manage the client—and we provide a convenient, transparent, and branded infrastructure.",
      m_partners_benefits_title: "What You Get",
      m_partners_benefits_1: "• Multi-Site management for clients with Site Keys and domain restrictions.",
      m_partners_benefits_2: "• White-Label at site level (logo/name/text), so you stay in front.",
      m_partners_benefits_3: "• Pricing model that enables natural upsell (sites/traffic/AI) instead of \"painful upgrade\".",
      m_partners_start_title: "How to Get Started",
      m_partners_start_1: "• Open a partner account (currently via form).",
      m_partners_start_2: "• Define packages/terms with us (reseller/commission).",
      m_partners_start_3: "• Receive installation template + onboarding process for clients.",
      m_partners_cta_talk: "Talk to Us",
      m_partners_cta_pricing: "See Pricing",

      // ---- Marketing v2 (layout / home / inner pages) ----
      mk_skip: "Skip to main content",
      mk_nav_main_aria: "Main navigation",
      mk_nav_start: "Get started",
      mk_menu_open: "Open menu",
      mk_menu_close: "Close menu",
      mk_switch_lang_aria: "החלפה לעברית",
      mk_new_tab: "opens in a new tab",
      mk_footer_disclaimer:
        "Accss provides assistive accessibility and consent-management tools. Using the widget and tools does not by itself guarantee legal or standards compliance; full accessibility also requires changes to your site's content and code, and we recommend consulting a qualified professional.",
      mk_hero_eyebrow: "Accessibility & privacy for your site — in one place",
      mk_hero_point_1: "One line of code or a WordPress plugin",
      mk_hero_point_2: "Never slows your site",
      mk_hero_point_3: "Hebrew, RTL and more languages",
      mk_w_alt: "Illustration: the Accss accessibility panel open on a website, next to the accessibility and cookie buttons",
      mk_w_title: "Accessibility tools",
      mk_w_sub: "Settings are saved on your device only",
      mk_w_lang: "EN",
      mk_w_search: "Search tools…",
      mk_w_active: "2 active adjustments",
      mk_w_reset: "Reset",
      mk_w_tab_quick: "Quick",
      mk_w_tab_text: "Text",
      mk_w_tab_colors: "Colors",
      mk_w_tab_nav: "Navigation",
      mk_w_help: "What would help you right now?",
      mk_w_p1_t: "Clearer display",
      mk_w_p1_d: "Larger text, readable font and high contrast",
      mk_w_p2_t: "Reading & focus",
      mk_w_p2_d: "Reading mask, comfortable spacing, paused animations",
      mk_w_on: "On",
      mk_trust_aria: "Key highlights",
      mk_pillars_eyebrow: "The product",
      mk_pillars_title: "Four tools, one dashboard",
      mk_pillars_sub: "Accessibility widget, cookie consent management, a compliance center and AI tools — managed from one place, for all your sites.",
      mk_pillar_widget_t: "Accessibility widget",
      mk_pillar_widget_d: "A modern accessibility panel with quick profiles, tool search, and text, color and navigation adjustments — in your branding.",
      mk_pillar_widget_c1: "Quick profiles",
      mk_pillar_widget_c2: "Display adjustments",
      mk_pillar_widget_c3: "White label",
      mk_pillar_privacy_t: "Privacy & cookies (Amendment 13)",
      mk_pillar_privacy_d: "A cookie consent banner, a separate preferences button and a privacy policy managed from the dashboard — to help you work in an organized way with Amendment 13 requirements.",
      mk_pillar_privacy_c1: "Consent banner",
      mk_pillar_privacy_c2: "Cookie preferences",
      mk_pillar_privacy_c3: "Privacy policy",
      mk_pillar_compliance_t: "Compliance center & statement",
      mk_pillar_compliance_d: "An accessibility statement you edit from the dashboard, compliance reports per site, and organized documentation of changes over time.",
      mk_pillar_compliance_c1: "Accessibility statement",
      mk_pillar_compliance_c2: "Compliance reports",
      mk_pillar_compliance_c3: "Scan comparison",
      mk_pillar_ai_d: "An AI scan that finds common issues — missing ALT, heading structure, form labels — and suggests fixes. It doesn't replace an expert, but it saves time.",
      mk_pillar_ai_c1: "AI audit",
      mk_pillar_ai_c2: "Image ALT",
      mk_pillar_ai_c3: "Contrast suggestions",
      mk_how_eyebrow: "How it works",
      mk_how_title: "Live in minutes",
      mk_how_sub: "Three simple steps — no development project, no changes to your site's design.",
      mk_how_1_t: "Add your site",
      mk_how_1_d: "Create an account, add your domain and get a dedicated Site Key.",
      mk_how_2_t: "Customize",
      mk_how_2_d: "Pick colors, position, language and tools, and edit your accessibility statement and privacy policy.",
      mk_how_3_t: "Install",
      mk_how_3_d: "Install the WordPress plugin or paste one line of code — and the widget is live.",
      mk_install_eyebrow: "Installation",
      mk_install_title: "Simple install that never slows your site",
      mk_install_sub: "The embed code only loads after your page has finished loading, in the background — so your site stays fast.",
      mk_install_point_1: "Non-blocking: loads after the page, during browser idle time",
      mk_install_point_2: "WordPress plugin — connect your account or paste a Site Key, done",
      mk_install_point_3: "The widget only runs on domains you approve",
      mk_install_tabs_aria: "Installation methods",
      mk_install_tab_code: "Code snippet",
      mk_install_tab_wp: "WordPress plugin",
      mk_install_code_note: "Copy the full snippet, with your Site Key, from the dashboard in one click.",
      mk_install_wp_1: "Install and activate the Accss Accessibility plugin",
      mk_install_wp_2: "Connect your Accss account or paste your Site Key",
      mk_install_wp_3: "Save — the widget appears on your site",
      mk_install_wp_note: "The plugin uses the same non-blocking loading as the embed code.",
      mk_resilience_t: "Never slows your site — even if our service is down",
      mk_resilience_d: "The code loads asynchronously and only after your page has finished loading. If the Accss server is unavailable for any reason, your site keeps working as usual — just without the widget until the service is back.",
      mk_resilience_pill_1: "Non-blocking load",
      mk_resilience_pill_2: "Your site always works",
      mk_pricing_teaser_t: "Transparent pricing that grows with you",
      mk_pricing_teaser_cta: "See all plans",
      mk_faq_eyebrow: "FAQ",
      mk_faq_title: "Questions & answers",
      mk_faq_1_q: "Does the widget affect my site's speed?",
      mk_faq_1_a: "Not noticeably. The code only loads after the page has finished loading and during browser idle time, so it doesn't block rendering. And even if our service is down, your site keeps working as usual.",
      mk_faq_2_q: "Is installing the widget enough to comply with the law?",
      mk_faq_2_a: "Not necessarily. The widget is an assistive tool that improves the browsing experience, but accessibility under Israeli Standard 5568 and WCAG also requires work on your content and code — alt text for images, heading structure, form labels and keyboard navigation. The dashboard tools help you find and document the gaps.",
      mk_faq_3_q: "How do I install on WordPress?",
      mk_faq_3_a: "Install the Accss Accessibility plugin, connect your account or paste the Site Key from the dashboard, and save. On other sites, paste one line of code into your site template.",
      mk_faq_4_q: "What does cookie management (Amendment 13) include?",
      mk_faq_4_a: "A cookie consent banner, a separate preferences button that lets visitors change their choice at any time, and a privacy policy you edit from the dashboard.",
      mk_faq_5_q: "Can I manage several sites from one account?",
      mk_faq_5_a: "Yes. Each site gets its own Site Key and domain restrictions, and you manage them all from the same dashboard — great for agencies and the partners track too.",

      // Pricing page
      mk_pr_eyebrow: "Pricing",
      mk_pr_interval_aria: "Billing period",
      mk_pr_per_month: "per month",
      mk_pr_per_year: "per year",
      mk_pr_includes: "Includes:",
      mk_pr_sites: "Up to {{n}} sites",
      mk_pr_pageviews: "{{n}} page loads per month",
      mk_pr_ai: "{{n}} AI credits per month",
      mk_pr_extra_site: "Extra site: ₪{{p}} per month",
      mk_pr_popular: "Recommended",
      mk_pr_empty: "No plans to show right now. Talk to us and we'll tailor one for you.",
      mk_pr_note: "Every plan: non-blocking loading that never slows your site, and full management from the dashboard.",
      mk_pr_custom_t: "Need a custom plan?",
      mk_pr_custom_d: "Agencies, many sites or high traffic — let's build a plan that fits you.",
      mk_pr_custom_cta: "Talk to us",
      mk_feat_font: "Text resizing",
      mk_feat_contrast: "High contrast",
      mk_feat_links: "Link highlighting",
      mk_feat_stopAnimations: "Stop animations",
      mk_feat_invertColors: "Invert colors",
      mk_feat_readableFont: "Readable font",
      mk_feat_readLine: "Reading line",
      mk_feat_lineHeight: "Line spacing control",
      mk_feat_letterSpacing: "Letter spacing control",
      mk_feat_statement: "Accessibility statement",
      mk_feat_aiAudit: "Smart accessibility audit (AI)",
      mk_feat_aiAltText: "Automatic image ALT (AI)",
      mk_feat_aiColorSuggestions: "Color/contrast suggestions (AI)",
      mk_feat_whiteLabel: "White label (no Accss branding)",
      mk_feat_branding: "Custom branding",

      // Inner pages
      mk_about_eyebrow: "Who we are",
      mk_standard_eyebrow: "Standard 5568 · WCAG",
      mk_standard_disclaimer_t: "Good to know",
      mk_info_eyebrow: "Guides",
      mk_partners_eyebrow: "For agencies and site builders",
      mk_install_page_eyebrow: "Installation",
      mk_install_page_sub: "A clear, measurable and managed installation process. Within minutes you get a Site Key and the widget is live (subject to an approved domain and an active subscription).",
      mk_install_page_steps_t: "Four steps to install",
      mk_install_page_method_t: "Two ways to embed",
      mk_install_start: "Get started",
      mk_install_pricing: "Pricing",
      mk_install_issues: "Common issues",
      mk_support_eyebrow: "Help",
      mk_support_faq_t: "Frequently asked questions",
      mk_sup_1_q: "Does the plugin affect site speed?",
      mk_sup_1_a: "The widget loads at the end of page load (it doesn't block rendering). In practice the impact is negligible, especially with a correct installation.",
      mk_sup_2_q: "Why doesn't the widget load on a local page (file://)?",
      mk_sup_2_a: "The server validates the domain by Origin/Referer. A local file has no valid Origin — test via {{url}} instead.",
      mk_sup_3_q: "How do I add several domains to the same site?",
      mk_sup_3_a: "When editing a site, the 'Domain' field accepts a comma-separated list (including *.example.com for subdomains).",
      mk_support_more_t: "Didn't find an answer?",
      mk_support_more_d: "Write to us and we'll get back to you with a solution.",
      mk_contact_eyebrow: "Talk to us",
      mk_contact_sub: "For a demo, pricing questions or technical help with installation — leave your details and we'll get back to you.",
      mk_contact_form_t: "Leave your details",
      mk_contact_side_t: "How we can help",
      mk_contact_side_1: "A demo of the widget and dashboard",
      mk_contact_side_2: "Questions about plans and pricing",
      mk_contact_side_3: "Help with installation and domain setup",
      mk_contact_side_4: "Partnerships and the partners track",

      // Auth pages
      mka_login_title: "Log in",
      mka_login_sub: "Log in to manage your sites",
      mka_login_btn: "Log in",
      mka_login_err: "Login failed",
      mka_google_login: "Log in with Google",
      mka_google_register: "Sign up with Google",
      mka_or: "or with email",
      mka_email: "Email",
      mka_password: "Password",
      mka_name: "Name",
      mka_forgot_link: "Forgot password",
      mka_no_account: "Don't have an account?",
      mka_register_link: "Sign up",
      mka_have_account: "Already have an account?",
      mka_login_link: "Log in",
      mka_register_title: "Create your account",
      mka_register_sub: "Add a site, customize and install — in minutes",
      mka_register_btn: "Create account",
      mka_register_err: "Registration failed",
      mka_forgot_title: "Forgot password",
      mka_forgot_sub: "Enter your email and we'll send you a reset link",
      mka_forgot_btn: "Send reset link",
      mka_forgot_done: "If the email exists in our system, a reset link has been sent to it.",
      mka_back_login: "Back to log in",
      mka_err: "Error",
      mka_set_title: "Set password",
      mka_set_sub: "Choose a new password for your account",
      mka_set_missing: "The link is missing a token",
      mka_set_done: "Password updated.",
      mka_set_new: "New password",
      mka_set_btn: "Save",
      mka_show_password: "Show password",
      mka_hide_password: "Hide password",
      mka_google_progress: "Signing in with Google…",
      mka_google_fail: "Google sign-in failed. Please try again.",

      // Payment result pages
      mkp_checking: "Checking payment status...",
      mkp_success_title: "Payment successful",
      mkp_msg_default: "Payment completed! Your subscription will update shortly.",
      mkp_msg_completed: "Payment approved and your subscription is active!",
      mkp_msg_pending: "Payment is processing. Your subscription will update in a few minutes.",
      mkp_msg_done: "Payment completed. Your subscription will update shortly.",
      mkp_msg_soon: "Payment completed! Your subscription will update in a few moments.",
      mkp_tx: "Transaction ID:",
      mkp_back_dash: "Back to dashboard",
      mkp_my_sites: "My sites",
      mkp_email_note: "You've received an email with your order details.",
      mkp_fail_title: "Payment failed",
      mkp_fail_msg: "The payment was not completed. You can try again.",
      mkp_cancel_title: "Payment canceled",
      mkp_cancel_msg: "The payment was canceled.",
      mkp_back_plans: "Back to plans",
      mkp_demo_title: "Test mode (Demo)",
      mkp_demo_warning: "This is test mode. No real payment will be made.",
      mkp_demo_amount: "Amount:",
      mkp_demo_iframe: "In production, the SmartPay payment iframe appears here.",
      mkp_demo_redirect: "Redirecting to the success page in {{n}} seconds...",
      mkp_demo_continue: "Continue to success",
      mkp_demo_fail: "Simulate: failure",
      mkp_demo_cancel: "Cancel",
      mkp_demo_env: "To enable real payments, set the SmartPay environment variables in ",

      // Plans page
      p_plans_title: "Plans",
      p_addons_title: "Add-ons",
      p_buy_button: "Purchase",
      p_yearly: "Yearly",
      p_monthly: "Monthly",
      p_features_label: "Features",
      p_includes: "Includes up to",
      p_sites_label: "sites",
      p_pageviews_label: "pageviews/month",
      p_ai_credits_label: "AI credits/month",
      p_no_ai_credits: "No AI credits",
      p_overage_traffic: "Traffic overage:",
      p_per_1000: "per 1,000 pageviews",
      p_extra_site: "Extra site:",
      p_per_month: "/month",
      p_payment_title: "Secure Credit Card Payment",
      p_payment_success: "Payment successful. Subscription updating…",
      p_payment_failed: "Payment not completed. You can try again.",
      p_payment_pending: "Enter payment details in the iframe. After approval—the package will update automatically.",
      p_payment_no_url: "No payment link received.",
      p_payment_open_new_window: "Open in new window",
      p_payment_close: "Close",

      // Profile page
      pr_profile_title: "Profile",
      pr_email_label: "Email:",
      pr_dark_mode: "Dark mode",
      pr_light_mode: "Light mode",
      pr_theme_desc: "Display mode is saved in the browser (Light/Dark) and applies to the entire system.",
      pr_name_label: "Name",
      pr_save_button: "Save",
      pr_updated_message: "Updated.",

      // Usage Dashboard
      usage_title: "Usage & Traffic",
      usage_month_label: "Month:",
      usage_metric_desc: "Current metric is Widget config loads (MVP).",
      usage_sites_count: "Sites:",
      usage_total_hits: "Total loads this month:",
      usage_plan_label: "Plan:",
      usage_quota_per_site: "Quota per site:",
      usage_no_limit: "No limit",
      usage_ai_credits_month: "AI credits/month:",
      usage_extra_sites: "Extra sites:",
      usage_extra_traffic: "Extra traffic/month:",
      usage_extra_ai: "Extra AI/month:",
      usage_no_subscription: "No active subscription",
      usage_table_site: "Site",
      usage_table_domain: "Domain",
      usage_table_hits_month: "Loads this month",
      usage_table_utilization: "Utilization",
      usage_table_remaining: "Remaining",
      usage_table_status: "Status",
      usage_status_exceeded: "Over plan · widget keeps running",

      overview: "Overview",
      dashboard: "Dashboard",
      usage: "Usage",
      theme_dark: "Dark mode",
      theme_light: "Light mode",
      back_to_marketing: "Back to marketing site",
      marketing_site: "Marketing site",
      open_menu: "Open menu",
      toggle_sidebar: "Collapse/expand sidebar",

      // Auth & User
      login: "Login",
      register: "Register",
      email: "Email",
      password: "Password",
      name: "Name",
      logout: "Logout",
      profile: "Profile",
      plans: "Plans",
      sites: "Sites",
      admin: "Admin",
      forgotPassword: "Forgot Password",
      setPassword: "Set Password",
      settings: "Settings",
      collapse: "Collapse Menu",
      expand: "Expand Menu",

      // Actions
      save: "Save",
      create: "Create",
      edit: "Edit",
      delete: "Delete",
      install: "Install",
      copy: "Copy",
      cancel: "Cancel",
      confirm: "Confirm",
      
      // Sites
      domain: "Domain",
      siteName: "Site Name",
      siteKey: "Site Key",
      sites_subtitle: "Manage your website integrations and configurations",
      sites_add_website: "Add Website",
      sites_no_sites: "No websites yet. Add your first site to get started.",
      sites_table_name: "Website Name",
      sites_table_status: "Status",
      sites_table_action: "Action",
      sites_confirm_delete: "Delete this website?",
      sites_menu_quickstart: "Quick Start",
      sites_menu_edit: "Edit Settings",
      sites_menu_install: "Installation Code",
      sites_menu_statement: "Accessibility Statement",
      sites_menu_reports: "Compliance Reports",
      sites_menu_delete: "Delete Site",
      sites_dialog_title: "Add New Website",
      sites_dialog_subtitle: "Configure your website integration",
      sites_name_placeholder: "My Website",
      sites_name_help: "A friendly name for your website",
      sites_domain_help: "Comma-separated list of domains",

      // Settings page
      settings_subtitle: "Manage your profile and account",
      settings_tab_profile: "Profile",
      settings_tab_billing: "Billing & Payment",
      settings_profile_title: "Personal Information",
      settings_name_help: "The name displayed in your account",
      settings_email_help: "Email address cannot be changed",
      settings_appearance_title: "Appearance",
      settings_billing_title: "Subscription & Payment Management",
      settings_billing_desc: "Manage your payment details, billing methods, and history",
      settings_payment_portal: "Payment Management Portal",
      settings_payment_portal_desc: "Update payment methods, view invoices and history",
      settings_opening: "Opening...",
      settings_open_portal: "Open Management Portal",
      settings_subscription_info: "Subscription Details",
      settings_subscription_desc: "View and change your plan",
      settings_view_plans: "View Plans",
      
      // Dashboard specific
      search_placeholder: "Search domains or reports...",
      admin_insights: "Insights",
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: localStorage.getItem("aw_lang") || "he",
  fallbackLng: "he",
  supportedLngs: ["he", "en"],
  interpolation: { escapeValue: false },
});

export default i18n;


